import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getpervStateTab } from "../../../redux/loansTab/loansTabSlice";
import { RootState } from "../../../redux/store";
import { IFormInnerState } from "../../requestSteps/form/IFormInnerState";
import Guarantor from "../../requestSteps/guarantors/guarantor";
import GuarantorCompletion from "../../requestSteps/guarantors/guarantorCompletion";
import GuarantorInfo from "../../requestSteps/guarantors/guarantorInfo";
import GuarantorRegister from "../../requestSteps/guarantors/guarantorRegister";
import { TGuarantorContainer } from "./TGuarantorContainer";
import { changeRouteType } from "../../../redux/handleBackBtn/handleBackBtnSlice";
import GuarantorOtp from "../../requestSteps/guarantors/otp/guarantorOtp";
import GuarantorInquiryResult from "../../requestSteps/guarantors/result/guarantorInquiryResult";
import InquiryOtp from "../../requestSteps/inquiryFee/otp/inquiryOtp";
import InquiryResult from "../../requestSteps/inquiryFee/result/inquiryResult";

export default function GuarantorContainer({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {
    const dispatch = useDispatch();
    const [innerState, setInnerState] = useState<TGuarantorContainer>('guarantorIntroduce');
    const stateFromRedux = useSelector((state: RootState) => state.prevAndNextState.nextInnerState) as TGuarantorContainer;
    useEffect(() => {
        if (stateFromRedux.includes('guarantorIntroduce'))
            setInnerState('guarantorIntroduce')
    }, [stateFromRedux])
    // let stateRedux: TGuarantorContainer;
    // //  = 'guarantorIntroduce';
    // stateRedux = useSelector((state: RootState) => state.loansTabComponents.prevState) as TGuarantorContainer;
    // if (stateRedux.includes('appContainer')) {
    //     stateRedux = 'guarantorIntroduce'
    // } else {
    //     stateRedux = stateRedux;
    // }
    const currentState = {
        'guarantorIntroduce': <Guarantor referenceKey={referenceKey} setInnerState={setInnerState} setStep={setStep} />,
        'guarantorCompletion': <GuarantorCompletion setInnerState={setInnerState} setStep={setStep} referenceKey={referenceKey} />,
        'guarantorInfo': <GuarantorInfo referenceKey={referenceKey} setInnerState={setInnerState} setStep={setStep} />,
        'guarantorRegister': <GuarantorRegister referenceKey={referenceKey} setInnerState={setInnerState} setStep={setStep} />,
        'otp': <GuarantorOtp setInnerState={setInnerState} referenceKey={referenceKey} />,
        'guarantorInquiryResult': <GuarantorInquiryResult referenceKey={referenceKey} setStep={setStep} setInnerState={setInnerState} />,
    }
    return (
        <div>
            {currentState[innerState!]}
        </div>
    )
}
